<div class="registered-appliance-summary">
  <p class="registered-appliance-summary__title">
    {{
      "REGISTERED_APPLIANCE_SUMMARY_TITLE"
        | translate: { applianceName: appliance()?.applianceName }
    }}
  </p>

  <app-description-list class="registered-appliance-summary__list">
    <app-description-list-item
      [data]="warrantyLengthInYearsLabel"
      [title]="
        'REGISTERED_APPLIANCE_SUMMARY_MANUFACTURER_WARRANTY_LENGTH' | translate
      "
      class="registered-appliance-summary__list-item"
    />
    @if (applianceModelNumber()) {
      <app-description-list-item
        [data]="applianceModelNumber()"
        [title]="'REGISTERED_APPLIANCE_SUMMARY_MODEL_NUMBER' | translate"
        class="registered-appliance-summary__list-item"
      />
    }
    <app-description-list-item
      [data]="appliancePurchaseDate()"
      [title]="'REGISTERED_APPLIANCE_SUMMARY_PURCHASE_DATE' | translate"
      class="registered-appliance-summary__list-item"
    />
  </app-description-list>

  <p class="registered-appliance-summary__disclaimer">
    {{ "REGISTERED_APPLIANCE_SUMMARY_DISCLAIMER" | translate }}
  </p>
</div>
